/**
 * Resolves ownership of Tago's ambient Liquid Canvas.
 *
 * A tab scene is already inside AppShell's canvas. Rendering a second set of
 * full-screen gradients below every ScreenContainer wasted GPU work while the
 * inner opaque background hid the outer one. A modal, however, is a separate
 * visual plane and can explicitly isolate its canvas. Keeping this decision
 * pure lets native, web and tests share the exact same contract.
 */
export function resolveLiquidCanvasLayer({
  hasAncestorCanvas,
  isolate,
  ambient,
  reducedTransparency,
}: {
  hasAncestorCanvas: boolean
  isolate: boolean
  ambient: boolean
  reducedTransparency: boolean
}) {
  const ownsCanvas = isolate || !hasAncestorCanvas

  return {
    ownsCanvas,
    // Reduced-transparency still owns a solid semantic background; it simply
    // skips the decorative gradients.
    rendersAmbient: ownsCanvas && ambient && !reducedTransparency,
  }
}
